<div cdkDropList [cdkDropListData]="combinedActionList" (cdkDropListDropped)="dropItem($event)">
  <div *ngFor="let sendgroup of groups">
    <send-group [sendgroups]="groups" [sendgroup]="sendgroup" [sortingAllowed]="(!workflowData || workflowData.allowSorting)"></send-group>

  </div>
</div>